import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'

import Home from './Home';
import Support from "./Support";
import EditUser from './EditUser';
import Tenant from "./Tenant";
import AddNewUser from "./AddNewUser";
import User from "./User";
import TenantUsers from './TenantUsers';
import Error from './Error';
import ResetPassword from "./ResetPassword";
import EditTenant from "./EditTenant"

import './App.css';
import LostPassword from "./LostPassword";

function App() {
  //sessionStorage.setItem("token", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJTaWduaW5NZXRob2QiOiJDbG91ZENUSSIsIlNpZ25pblVzZXIiOiJwYXJ2YS5hcmFzaEBnbWFpbC5jb20iLCJTaWduaW5QYXNzd29yZCI6Iko0LytnYjhuWEw4NDAwaWNpdGlUMUpFL1UyUHNRRVhDMHQxM3h3RFVraHpWdEVXUngxeW5wd09BYms2MFl0MUd0RWMyWS9FWGt6dnpvRWVqb3U3OC85Z1RISUtaeFZkVDMzVHd5WUI1S0Z1Smp6OWw1aFZ2aGlQdlUzYjlUZlA2IiwiU2lnbmluQXBwbGljYXRpb24iOiJVc2VyUG9ydGFsIiwiVGVuYW50R3VpZCI6IlRlbmFudF9hZjFiMDA4NS0xODU1LTQyNmQtODhkNC05OTM0YmVlYzgyOWQiLCJUZW5hbnROYW1lIjoiR21haWwiLCJVc2VyR3VpZCI6IlRlbmFudFVzZXJfZjlkNzc0OTAtZWNiMy00YTUxLTllNmYtMzE4MWU2NzE5OTI4IiwiVXNlck5hbWUiOiJBcmFzaCByZXNlbGxlciB0ZXN0IGFjY291bnQiLCJVc2VySXNBZG1pbiI6IjEiLCJVc2VySXNUZW5hbnRBZG1pbiI6IjEiLCJFbWFpbCI6InBhcnZhLmFyYXNoQGdtYWlsLmNvbSIsIlJlc2VsbGVyT3duZXJHdWlkIjoiUmVzZWxsZXJfNzQ0ODk2RTMtRjY4MS00NDk5LTgyMUEtMkE5ODFBOThEMDgzIiwiUm9sZXMiOiJVc2VyIiwiZXhwIjoxNzY2MjM2MzM1LCJpc3MiOiJzaWduaW4tdmEiLCJhdWQiOiJDbG91ZENUSTIwMjIifQ.w3WkuwvO-fZfJB1_uARCjUF-vrn0ukTYjlRwcttEEIk")
  //const token = sessionStorage.getItem("token");
  const token = Cookies.get("userportal");
  
  let isAuthenticated = false;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
        isAuthenticated = true;
        sessionStorage.setItem("username", decodedToken.UserName);
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("userguid", decodedToken.UserGuid);
        sessionStorage.setItem("tenantguid", decodedToken.TenantGuid);
        sessionStorage.setItem("UserIsTenantAdmin", decodedToken.UserIsTenantAdmin);
        sessionStorage.setItem("UserEmailAddress", decodedToken.Email)
        sessionStorage.setItem("UserIsAdmin", decodedToken.UserIsAdmin)
        console.log("USerIsAdmin:" + decodedToken.UserIsAdmin)
      
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  }

  const redirectToLogin = () => {
    const redirecturl = window.location.href.replaceAll(":", "%3A").replaceAll("/", "%2F").replaceAll("&", "%26");
    window.location.href = "https://signin-va.cloudcti.nl/signin/onelogin?clientid=userportal&redirecturl=" + redirecturl;
  };

  if (!isAuthenticated && window.location.pathname !== "/resetpassword" && window.location.pathname !== "/lostpassword"){
    redirectToLogin()
    return null; // Avoid rendering any routes until redirection happens
  }

  return (
    <Router>
      <Routes>
        {/* Public route: accessible without authentication */}
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/lostpassword" element={<LostPassword />} />

        {/* Protected routes: require authentication */}
        {isAuthenticated && (
          <>
            <Route path="/home" element={<Home />} />
            <Route path="/" element={<Home />} />
            <Route path="/support" element={<Support />} />
            <Route path="/edituser" element={<EditUser />} />
            <Route path="/tenant" element={<Tenant />} />
            <Route path="/addnewuser" element={<AddNewUser />} />
            <Route path="/user" element={<User />} />
            <Route path="/tenantusers" element={<TenantUsers />} />
            <Route path="/error" element={<Error />} />
            <Route path="/edittenant" element={<EditTenant/>} />
          </>
        )}
      </Routes>
    </Router>
  );
}

export default App;
